import { logStartGreyError, logStartUsage } from "owa-analytics-start";
import { isRunningInMetaOSHub } from "owa-config";
import { tryGetGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { lazyGetContext } from "owa-metaos-app-bootstrap";
import { getBootCustomData } from "owa-performance";

/**
 * Fetches the user session from the MetaOS context.
 *
 * Note: Never throw an error in this function.
 */
export default async function logUserSessionFromMetaOSContext(source: string): Promise<void> {
    try {
        if (!isRunningInMetaOSHub()) {
            return;
        }
        
        const context = await lazyGetContext.importAndExecute();
        
        logStartUsage("PlacesGetMetaOSContext", tryGetGlobalSettingsAccountMailboxInfo(), {
            source,
            hostSessionId: getBootCustomData().HostSessionId,
            /* eslint-disable-next-line owa-custom-rules/telemetry-no-nested-objects -- (https://aka.ms/OWALintWiki)
             * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
             *	> Do not call JSON.stringify(...) in logStartUsage telemetry data. Log flat, scalar custom-data fields instead of stringified or nested data; nested blobs force expensive, bug-prone recursive JSON parsing in the downstream pipeline. */
            metaOSContext: JSON.stringify({
                app: {
                    locale: context.app.locale,
                    theme: context.app.theme,
                    sessionId: context.app.sessionId,
                    host: context.app.host,
                    appLaunchId: context.app.appLaunchId,
                    appId: context.app.appId?.toString(),
                    manifestVersion: context.app.manifestVersion,
                },
                user: {
                    id: context.user?.id,
                    tenant: context.user?.tenant,
                },
                page: context.page,
            }),
        });
    }
    catch (err) {
        logStartGreyError("PlacesGetMetaOSContextError", tryGetGlobalSettingsAccountMailboxInfo(), err instanceof Error ? err : undefined);
    }
}
